import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OAuthModule } from 'angular-oauth2-oidc';
import { Api } from '../../services/api';
import { Auth } from '../../services/auth';
import { environment } from '../../../environments/environment';
import { Sso } from '../../services/sso';
import { Common } from '../../services/common';

@Component({
  selector: 'app-login-callback',
  imports: [CommonModule, OAuthModule],
  providers: [OAuthModule],
  templateUrl: './login-callback.html',
  styleUrl: './login-callback.scss',
})
export class LoginCallback implements OnInit, OnDestroy {
  constructor(private router: Router, private route: ActivatedRoute, private apiService: Api,
    private authService: Auth, private ssoService: Sso, private commonService: Common){ }

  loading: boolean = false;
  loadingMessage: string = 'Authenticating...';
  private subscription: any = [];

  ngOnInit() {
    console.log('Login Callback Init');
    this.loading = true;
    this.route.queryParams.subscribe((params) => {
      console.log('Login Callback: Query Params:', params);
      const associateId = params['EncryptedAssociateId'] || params['associateId'] || null;
      const code = params['code'] || null;
      if (associateId && associateId !== '') {
        console.log('Login Callback: Associate ID from query params:', associateId);
        this.getAccessForAssociate(associateId);
      } else if (code) {
        console.log('Authorization Code:', code);
        //call api
        this.getTokenAndRedirect(code);
      } else {
        console.log('Authorization code not found in query parameters.');
        this.loading = false;
        this.router.navigate(['/login-error']);
      }
    });
  }

  getAccessForAssociate(associateId: string) {
    const payload = {
      associate_id: associateId
    };
    this.subscription['getAccessToken'] = this.apiService.getAccessDetails(payload).subscribe({
      next: (response) => {
        // console.log('User Access Details Response:', response);
        if (response && response.access_token && response.access_token != '') {
          let userDetails = this.generateUserDetails(response);
          userDetails.access_token = response.access_token;
          this.ssoService.setUserAccess(userDetails);
          this.loading = false;
          const role = userDetails.role ? userDetails.role.toLowerCase() : '';
          this.navigateByRole(role);
        } else {
          console.log('Invalid token response for Associate:', response);
          this.authService.setAuthenticationError('Invalid User!');
          this.loading = false;
          this.router.navigate(['/login-error']);
        }
      },
      error: (e) => {
        console.log('Error while fetching access details for Associate:', JSON.stringify(e));
        this.authService.setAuthenticationError('Authentication Process Failed! Please try again later.');
        this.loading = false;
        this.router.navigate(['/login-error']);
      },
      complete: () => {
        this.loading = false;
      },
    });
  }

  getTokenAndRedirect(code: string) {
    const payload = {
      code: code,
      redirect_uri: this.authService.authConfig.redirectUri
    };
    this.subscription['getAccessToken'] = this.apiService.getAccessToken(payload).subscribe({
      next: (response) => {
        console.log('Access Token Response: API', response);
        if (response && response.access_token && response.access_token != '') {
          this.authService.setAccessToken(response?.access_token ?? '', response?.expired_in ?? 3540);
          this.authService.clearAuthenticationError();
          this.authService.setEncryptionKey();
          // this.authService.setUserDetails(response);
          let userDetails = this.generateUserDetails(response);
          this.authService.setUserDetails(userDetails)
          this.loading = false;
          // this.router.navigate(['/dashboard']);
          const role = userDetails.role ? userDetails.role.toLowerCase() : '';
          this.navigateByRole(role);
        } else {
          console.log('Invalid token response:', response);
          this.authService.setAuthenticationError('Invalid User!');
          this.loading = false;
          this.router.navigate(['/login-error']);
        }
      },
      error: (e) => {
        console.log('Error while fetching access token:', JSON.stringify(e));
        this.authService.setAuthenticationError('Authentication Process Failed! Please try again later.');
        this.loading = false;
        this.router.navigate(['/login-error']);
      },
      complete: () => {
        this.loading = false;
      },
    });
  }

  generateUserDetails(response: any): any {
    return {
            eid: response.associate_id,
            name: response.name,
            email: response.email,
            flm_name: response.flm_name ?? '',
            is_active: response.is_active ?? false,
            picture: response.picture ?? null,
            message: response.message ?? '',
            risk_officer_role: response.risk_officer_role ?? '',
            role_category_id: response.role_category_id ?? null,
            role_category_name: response.role_category_name ?? '',
            role: response.role_category_name ?? '',
            expires_in: response.expires_in,
          }
  }

  navigateByRole(role: string): void {
    const path = this.commonService.getNavigateByRole(role);
    this.router.navigate([path]);
  }

  ngOnDestroy() {
    Object.keys(this.subscription).forEach((key) => {
      this.subscription[key].unsubscribe();
    });
  }
}
